export default "__VITE_ASSET__Bt7bE84X__"